<div class="cookie-policy">
    <iframe src="https://app.termly.io/document/cookie-policy/25c5e64e-3c6e-4516-b580-22789b74d02e" width="100%"
        height="4280px" frameborder="0"></iframe>
</div>

<div class="cookie__message-holder" *ngIf="!isShowCookie && currentLanguage == 'ar'">
    <div class="cookie__message-info">
        <h3 class="cookie__info-title">
            هذا المحتوى متوفر باللغة الإنجليزية
        </h3>
        <a (click)="showCookie()">Cookie Policy</a>
    </div>
</div>